import React from 'react';
import { Box, Button, Tooltip, Typography } from '@mui/material';
import { COLOR_PRIMARY_2 } from 'src/colors';

const TooltipedActionButton = ({
  title,
  onClick,
  icon: IconComponent,
  label,
  smallLabel,
}: {
  title: string;
  onClick: () => void;
  icon: any;
  label: string;
  smallLabel?: boolean;
}) => {
  return (
    <Tooltip title={title}>
      <Button onClick={onClick}>
        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
          <IconComponent sx={{ fontSize: 24, color: COLOR_PRIMARY_2 }} />
          {smallLabel ? (
            <Typography sx={{ color: 'black', fontSize: '10px' }}>
              {label.split(' ').map((word, index) => (
                <span key={index}>
                  {word}
                  {index < label.split(' ').length - 1 && <br />}
                </span>
              ))}
            </Typography>
          ) : (
            <Typography variant="caption" sx={{ color: 'black' }}>
              {label}
            </Typography>
          )}
        </Box>
      </Button>
    </Tooltip>
  );
};

export default TooltipedActionButton;
